import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive } from 'vue'
import trackOrderView from "@/views/order/trackOrder/trackOrderView.vue";
import { stopTask } from '@/api/home';
import { useRoute, useRouter } from "vue-router";
import message from 'ant-design-vue/lib/message';

export default /*#__PURE__*/_defineComponent({
  __name: 't804',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const data = reactive({
    spinning:false
})

const onFinishTask = () => {
    data.spinning = true
    let option = {
        processDefinitionId: route.query.processDefinitionId,
        processDefinitionKey: route.query.processDefinitionKey,
        processInstanceId: route.query.processInstanceId,
        runTimeTaskId: route.query.runTimeTaskId,
        taskCode: route.query.taskCode,
        params: {
            oralTrackOrderId: route.query.oralTrackOrderId,
        },
    };
    stopTask(option).then(() => {
        data.spinning = false
        message.success("操作成功");
        router.push({
            path: "/home",
        });
    }).catch(() => {
        data.spinning = false
    })
};


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, {
      title: "监控",
      bordered: false
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, { onClick: onFinishTask }, {
          default: _withCtx(() => [
            _createTextVNode("结束")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(trackOrderView)
  ]))
}
}

})